import { STATUS_STYLE, RESEARCH_STATUS } from "../lib/constants";

export const EvidenceBadge = ({ status, testId }) => {
  const s = STATUS_STYLE[status] || STATUS_STYLE["Unable to assess"];
  const { Icon } = s;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold ${s.cls}`}>
      <Icon className="h-3 w-3" /> {status}
    </span>
  );
};

export const ResearchBadge = ({ status, testId }) => {
  const s = RESEARCH_STATUS[status || "not_researched"] || RESEARCH_STATUS.not_researched;
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold ${s.cls}`}>
      {status === "running" && <span className="pulse-dot mr-1.5 h-1.5 w-1.5 rounded-full bg-orange-600" />}
      {s.label}
    </span>
  );
};
